import React from 'react';
import { ParticipantHubLayout } from './ParticipantHubLayout';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, CoffeeIcon, UtensilsIcon, MoonIcon, WifiIcon, PhoneIcon } from 'lucide-react';
export function ArrivalBriefingPage() {
  return <ParticipantHubLayout data-id="element-4589">
      <div className="p-6 lg:p-8 max-w-5xl mx-auto space-y-8" data-id="element-4590">
        <div data-id="element-4591">
          <h1 className="font-serif-display text-4xl text-slate-900 mb-2" data-id="element-4592">
            Arrival Briefing
          </h1>
          <p className="text-slate-500" data-id="element-4593">
            Your guide to Day 1 at the Moon Palace Cancún.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-4594">
          {/* Timeline */}
          <div className="lg:col-span-2 space-y-6" data-id="element-4595">
            <h2 className="font-serif-display text-2xl text-slate-900 mb-4" data-id="element-4596">
              Day 1 Timeline
            </h2>
            <div className="relative border-l-2 border-slate-200 ml-4 space-y-8 pb-4" data-id="element-4597">
              {[{
              time: '2:00 PM',
              title: 'Arrival & Check-in',
              location: 'Main Lobby',
              desc: 'Proceed to the dedicated Finova Capital check-in desk. Your room keys and welcome kit will be waiting.',
              icon: MapPinIcon
            }, {
              time: '3:00 PM - 5:00 PM',
              title: 'Free Time & Settle In',
              location: 'Resort Grounds',
              desc: 'Take time to unpack, explore the property, or relax by the pool before the evening program begins.',
              icon: CoffeeIcon
            }, {
              time: '6:00 PM',
              title: 'Welcome Reception',
              location: 'Ocean Terrace',
              desc: 'Join the leadership team for sunset cocktails and light hors d’oeuvres.',
              icon: UtensilsIcon
            }, {
              time: '7:30 PM',
              title: 'Opening Dinner & Keynote',
              location: 'Grand Ballroom',
              desc: 'Opening remarks by CEO Marcus Chen, followed by a three-course dinner.',
              icon: MoonIcon
            }].map((event, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.1
            }} className="relative pl-8" data-id="element-4598">
                  <div className="absolute -left-[21px] top-1 w-10 h-10 rounded-full bg-white border-2 border-amber-500 flex items-center justify-center shadow-sm" data-id="element-4599">
                    <event.icon className="w-4 h-4 text-amber-600" data-id="element-4600" />
                  </div>
                  <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-4601">
                    <div className="flex items-center gap-2 text-sm font-bold text-amber-600 mb-1" data-id="element-4602">
                      <ClockIcon className="w-4 h-4" data-id="element-4603" />
                      {event.time}
                    </div>
                    <h3 className="font-bold text-lg text-slate-900 mb-1" data-id="element-4604">
                      {event.title}
                    </h3>
                    <div className="flex items-center gap-1 text-sm text-slate-500 mb-3" data-id="element-4605">
                      <MapPinIcon className="w-3.5 h-3.5" data-id="element-4606" />
                      {event.location}
                    </div>
                    <p className="text-slate-600 text-sm" data-id="element-4607">{event.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6" data-id="element-4608">
            {/* Venue Overview */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm" data-id="element-4609">
              <div className="h-40 overflow-hidden" data-id="element-4610">
                <img src="https://images.unsplash.com/photo-1582719478250-c894e4dc240e?auto=format&fit=crop&w=800&q=80" alt="Resort" className="w-full h-full object-cover" data-id="element-4611" />
              </div>
              <div className="p-6" data-id="element-4612">
                <h3 className="font-serif-display text-xl text-slate-900 mb-4" data-id="element-4613">
                  Moon Palace Cancún
                </h3>
                <div className="space-y-3" data-id="element-4614">
                  <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-4615">
                    <WifiIcon className="w-4 h-4 text-amber-500" data-id="element-4616" />
                    Network: FinovaSummit / Pass: Summit2026
                  </div>
                  <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-4617">
                    <MapPinIcon className="w-4 h-4 text-amber-500" data-id="element-4618" />
                    Sessions in the South Wing
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Your Hosts */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4619">
              <h3 className="font-serif-display text-xl text-slate-900 mb-4" data-id="element-4620">
                Your Support Team
              </h3>
              <div className="space-y-4" data-id="element-4621">
                <div className="flex items-center gap-3" data-id="element-4622">
                  <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" data-id="element-4623">
                    <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80" alt="Host" className="w-full h-full object-cover" data-id="element-4624" />
                  </div>
                  <div data-id="element-4625">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4626">
                      Amanda Torres
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4627">
                      Lead Facilitator
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-4628">
                  <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" data-id="element-4629">
                    <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=200&q=80" alt="Concierge" className="w-full h-full object-cover" data-id="element-4630" />
                  </div>
                  <div data-id="element-4631">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4632">
                      James Wilson
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4633">
                      Summit Concierge
                    </div>
                  </div>
                </div>
                <button className="w-full mt-2 py-2 border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors flex items-center justify-center gap-2" data-id="element-4634">
                  <PhoneIcon className="w-4 h-4" data-id="element-4635" />
                  Contact Concierge
                </button>
              </div>
            </motion.div>

            {/* Wellness */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-amber-50 rounded-2xl border border-amber-100 p-6 shadow-sm" data-id="element-4636">
              <h3 className="font-serif-display text-xl text-slate-900 mb-2" data-id="element-4637">
                Wellness & Rhythm
              </h3>
              <p className="text-sm text-slate-700 mb-4" data-id="element-4638">
                To help with the time zone adjustment, we recommend a 15-minute
                walk on the beach upon arrival. The Awe Spa is also available
                for express treatments.
              </p>
              <button className="text-amber-700 text-sm font-semibold hover:text-amber-800" data-id="element-4639">
                Book Spa Treatment &rarr;
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    </ParticipantHubLayout>;
}